import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openTooltip } from "../../../../store/actions";
import { SlotType } from "../../../../lib/types";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  slotType: SlotType;
  selectedBuilding: number;
  showSingleBuilding?: boolean;
}

const BuildingDetailInfoIcon = ({
  slotType,
  selectedBuilding,
  showSingleBuilding
}: IProps) => {
  const iconRef = useRef<HTMLAnchorElement>(null);
  const allBuildings = useSelector((state: DragescentState) => state.governorate.allBuildings);
  const slotPrices = useSelector((state: DragescentState) => state.governorate.slotPrices);
  const dispatch = useDispatch();
  const chainBuildings = allBuildings.filter((b: SlotType) => b.chain === slotType.chain);

  return (
    <a
      ref={iconRef}
      onClick={() => dispatch(openTooltip(!showSingleBuilding && chainBuildings.length > 1
        ? {
          name: "BuildingChainDetail",
          dynamic: true,
          classes: ["new-manor", "upgrade"],
          chainBuildings,
          slotPrices,
          selectedBuilding,
          elementRef: iconRef
        }
        : {
          name: "BuildingDetail",
          dynamic: true,
          classes: ["new-manor", "upgrade"],
          building: slotType,
          slotPrices,
          elementRef: iconRef
        }))}
    >
      <i className={`icon-circle white`}>?</i>
    </a>
  )
}

export default BuildingDetailInfoIcon;
